import { useDisclosure } from "@chakra-ui/react";
import { createContext } from "react";

type Props = {
  children: React.ReactNode;
};

export const NotificationContext = createContext({
  isOpen: false,
  onClose: () => {},
  onOpen: () => {},
});

export const NotificationContextProvider = ({ children }: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <NotificationContext.Provider value={{ isOpen, onOpen, onClose }}>
      {children}
    </NotificationContext.Provider>
  );
};
